export const formatExtrasPriceDetails = (
  extras?: Content.Components['ExtrasPriceDetailsDto'][],
) => {
  type Extra = Content.Components['ExtrasPriceDetailsDto'];

  return (extras ?? []).reduce(
    (acc, item) => {
      acc[item.productType].push(item);

      return acc;
    },
    {
      stay: [] as Extra[],
      travel: [] as Extra[],
    },
  );
};
